/**
 * @file api-shops.ts
 * @description API-клиент для списка магазинов (phase08, admin-picker).
 */

import { apiFetch } from "./api-client";

export interface ShopPublicDto {
  id: string;
  slug: string;
  displayName: string;
  isActive: boolean;
}

export const shops = {
  list: () => apiFetch<ShopPublicDto[]>("/admin/shops"),
};
